// @flow
import PageStatic from 'components/page/PageStatic';
import { connect } from 'react-redux';
import { fetchPageList } from 'actions/pageActions';

import type { DispatchProps } from 'components/page/PageStatic';
import type { DispatchType, StateType } from 'types/Actions';
import type {StateProps} from 'components/page/PageStatic';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      title: state.pageListState.title,
      description: state.pageListState.description,
      label: state.pageListState.label,
      featured_media: state.pageListState.featured_media,
      status: state.pageListState.status,
      redirection: state.pageListState.redirection,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug))
    })
  )(PageStatic)
);
